module.exports = __webpack_public_path__ + "img/filter-circle-outline.c25a85db.svg";